import { Component, EventEmitter, Inject, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwContainerOptions, DwContext, DwExpressionService, DwFormContextMode, DwMdFormContextInfo, DwMessage, DwMessageSeverity, DwMetaDataFormApi, DwMetaDataFormConfig, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwSectionBasePreference, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwUiConfigRegistryService, deepCopy, formatDateTimeFromLocal } from '@devwareapps/devware-cap';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { ExaminerRepositoryService } from '../../services/examiner-repository.service';
import { AppMetaData, AppMetaDataItemNames, ApplicantPlaceholderEntity, CheckRideApplicantTypeAllItems, CheckRideOutcomeAllItems, CheckRideRequestEntity, CheckRideRequestSubStatusAllItems, CheckRideResultEntity, CheckRideScenarioEntity, PilotExaminerLocationEntity, PilotExaminerSearchQueryEntity } from '../../../../meta-data/app-meta-data.service';
import { ExaminerLocationSearchRequest } from '../../models/examiner-location-search-request.model';
import { ExaminerLocationSelection } from '../../models/exminer-location-selection.model';
import { tap } from 'rxjs/operators';
import { CheckrideReferenceInfo } from '../../models/checkride-reschedule-info.model';

import { PlanOfActionRepositoryService } from '../../../plan-of-action/services/plan-of-action-repository.service';
import { ExaminerBookingVariableContext } from '../../../booking/models/examiner-booking-variable-context.model';

@DwComponent({
  key: 'exminer-check-ride-util',
  name: ' Examiner Check Ride Util',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.CheckRideRequest,
  isGlobal: false
})
@Component({
  selector: 'app-examiner-check-ride-util',
  template: `
  `
})
export class ExaminerCheckRideUtilComponent extends DwSectionBaseComponent {
  checkRideRequest: CheckRideRequestEntity;

  initComplete = false;
  rescheduleInfo: CheckrideReferenceInfo;
  checkrideScenarioId: number;
  currentScenario: any;
  checkRideTypeId: number;
  checkrideResultActualDateTime: string;
  formApi: DwMetaDataFormApi;
  applicantDataUpdated: boolean;
  isRebook: boolean;
  testTypeId: number;
  originalCheckRideRequest: any;
  lastCheckRideRequest: CheckRideRequestEntity;
  testTypes: any;
  outcomes: any;
  allAcsTests: import("c:/Projects/DevwareGit/Pilexos/PilexosCAPAngular/src/app/meta-data/app-meta-data.service").AcsTestCheckRideTypeEntity[];

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private examinerRepositoryService: ExaminerRepositoryService,
    private planOfActionRepositoryService: PlanOfActionRepositoryService
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

    this.formApi = this.dwMetaDataFormStateService.state.formApi;
  }

  ngOnInit(): void {
    this.setupDataWatch();

    this.loadReferenceData();
  }

  loadReferenceData() {
    const testTestsOb = this.examinerRepositoryService.getCheckrideTestTypes();
    const outcomesOb = this.examinerRepositoryService.getCheckrideOutcomes();
    const allAcsTestsOb = this.planOfActionRepositoryService.getAcsTestByCheckRideTypeAll();

    combineLatest([testTestsOb, outcomesOb, allAcsTestsOb]).subscribe(([testTypes, outcomes, allAcsTests]) => {
      this.testTypes = testTypes;
      this.outcomes = outcomes;
      this.allAcsTests = allAcsTests;
    });
  }

  setupDataWatch() {
    this.formApi.getFormDataChanges(100)
      .subscribe(dataChange => {
        if (this.formApi.isDataLoadComplete) {
          this.checkForDataChange();
        }
      });

    if (this.formApi.isDataLoadComplete) {
      this.checkForDataChange();
    }
  }

  protected checkForDataChange() {

    const checkRideRequest = this.formApi.getFormData<CheckRideRequestEntity>();

    if (this.checkRideRequest && checkRideRequest && this.checkRideRequest.CheckRideRequestSubStatusId != checkRideRequest.CheckRideRequestSubStatusId) {
      switch (this.checkRideRequest.CheckRideRequestSubStatusId) {
        case CheckRideRequestSubStatusAllItems.NewDateProposedByExaminer:
          this.updateProposedInfo(checkRideRequest);
      }
    }

    if (!this.originalCheckRideRequest) {
      this.originalCheckRideRequest = checkRideRequest;
    }
    this.checkRideRequest = checkRideRequest;

    this.initCheckride();

    this.checkForScheduleDateTimeChange();

    if (this.checkrideScenarioId !== checkRideRequest.ScheduledCheckRideScenarioId || (this.testTypeId != checkRideRequest.CheckRideTestTypeId && this.testTypeId)) {
      this.updateCheckrideScenario(checkRideRequest.ScheduledCheckRideScenarioId);
    }

    this.checkrideScenarioId = checkRideRequest.ScheduledCheckRideScenarioId;

    if (this.checkRideTypeId !== checkRideRequest.CheckRideTypeId) {
      this.setScenarioFromCheckrideType(checkRideRequest);
    }

    this.checkRideTypeId = checkRideRequest.CheckRideTypeId;

    if (!this.checkRideRequest?.CheckRideResult?.CheckRideDateTime &&
      (this.checkRideRequest?.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.Completed
        || this.checkRideRequest?.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingOutcome
      )) {
      this.updateCheckRideResultActualDateTime();
    }

    if (this.checkRideRequest?.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingOutcome && this.checkRideRequest?.CheckRideResult?.CheckRideOutcomeId) {
      this.updateCheckRideResultActualDateTime();
    }

    this.checkrideResultActualDateTime = this.checkRideRequest?.CheckRideResult?.CheckRideDateTime;

    if (this.checkRideRequest?.ApplicantPlaceholderId && this.dwMetaDataFormStateService.state.formContext.contextMode == DwFormContextMode.add) {
      this.setApplicantData();
    }

    this.checkForRebook();

    this.setAcsTest();

    this.lastCheckRideRequest = checkRideRequest;
  }

  setApplicantData() {
    if (this.isRebook || this.applicantDataUpdated) {
      return;
    }

    this.applicantDataUpdated = true;

    this.examinerRepositoryService.getApplicantPlaceholder(this.checkRideRequest.ApplicantPlaceholderId)
      .subscribe(applicantPlaceholder => {
        this.updateApplicantData(applicantPlaceholder);
      });
  }

  updateApplicantData(applicantPlaceholder: ApplicantPlaceholderEntity) {
    let checkrideRequest: Partial<CheckRideRequestEntity> = {
      StudentApplicantNameManual: applicantPlaceholder.StudentApplicantNameManual,
      StudentApplicantEmailManual: applicantPlaceholder.StudentApplicantEmailManual,
      StudentApplicantPhoneManual: applicantPlaceholder.StudentApplicantPhoneManual,
      CheckRideGroupId: applicantPlaceholder.CheckRideGroupId,
      CheckRideTypeId: applicantPlaceholder.CheckRideTypeId,
      ScheduledAirportId: applicantPlaceholder.PreferredAirportId,
      PilotCertificateNumber: applicantPlaceholder.PilotCertificateNumber,
      CheckRideTestTypeId: applicantPlaceholder.CheckRideTestTypeId,
      FlightSchoolName: applicantPlaceholder.FlightSchoolName,
      FlightInstructorName: applicantPlaceholder.FlightInstructorName,
      StudentApplicantId: applicantPlaceholder.StudentApplicantId,
      CheckRideApplicantTypeId: CheckRideApplicantTypeAllItems.ManualEntry,
      AuthorityPreCheckRideNumber: applicantPlaceholder.AuthorityPreCheckRideNumber,
      StudentApplicantCitizenshipCountyId: applicantPlaceholder.StudentApplicantCitizenshipCountyId,
      AvaiationTrainingProgramId: applicantPlaceholder.AviationTrainingProgramId,
      DocumentsMediaGroupId: applicantPlaceholder.DocumentsMediaGroupId
    };

    // if we have the last checkride, let's just use that and copy all the info
    if (applicantPlaceholder.CheckRideRequest?.length > 0) {
      const previousCheckride = applicantPlaceholder.CheckRideRequest[0];

      let newPreviousCheckride = { ...previousCheckride, ...checkrideRequest };

      console.debug('Check applicant missing data ', previousCheckride, newPreviousCheckride);

      this.updateCheckrideForRebook(newPreviousCheckride);

      return;
    }

    setTimeout(() => {
      this.formGroup.patchValue(checkrideRequest);
      this.formApi.patchFormData(checkrideRequest);
    }, 50);
  }

  private initCheckride() {
    if (this.initComplete) {
      return;
    }

    this.checkrideScenarioId = this.checkRideRequest?.ScheduledCheckRideScenarioId;
    this.checkRideTypeId = this.checkRideRequest?.CheckRideTypeId;


    this.initComplete = true;
    this.rescheduleInfo = this.examinerRepositoryService.getCheckrideReferenceInfo(this.checkRideRequest.CheckRideRequestId || -1);

    this.checkrideResultActualDateTime = this.checkRideRequest?.CheckRideResult?.CheckRideDateTime;


    if (!this.rescheduleInfo) {
      return;
    }

    if (this.rescheduleInfo.proposedStartDateTime) {
      this.handleReschedule();
      return;
    }

    if (this.rescheduleInfo.startDateTime) {
      this.checkRideRequest.ScheduledDateTime = this.rescheduleInfo.startDateTime;

      if (this.rescheduleInfo.durationMinutes) {
        this.checkRideRequest.ScheduledTimeMinutes = this.rescheduleInfo.durationMinutes;
      }

      this.formGroup.patchValue(this.checkRideRequest);
    }
  }

  setScenarioFromCheckrideType(checkRideRequest: CheckRideRequestEntity) {
    const scenarios = this.examinerRepositoryService.getCurrentCheckRideScenarios()
      .subscribe(scenarios => {
        const scenario = scenarios.find(scenario => scenario.IsActive && scenario.CheckRideScenarioTypeMap.find(tm => tm.CheckRideTypeId == checkRideRequest.CheckRideTypeId));

        if (scenario) {
          this.checkrideScenarioId = scenario.CheckRideScenarioId;

          this.updateCheckrideScenarioDefaults(scenario);
        }
      });
  }

  updateCheckrideScenario(checkRideScenarioId: number) {
    this.testTypeId = this.checkRideRequest.CheckRideTestTypeId
    this.examinerRepositoryService.getCurrentCheckRideScenario(checkRideScenarioId)
      .subscribe(scenario => {
        this.currentScenario = scenario;

        if (!scenario) {
          return;
        }

        this.updateCheckrideScenarioDefaults(scenario);
      });
  }

  // setAcsTest() {
  //   if (!this.checkRideRequest?.CheckRideTypeId) {
  //     return;
  //   }


  //   if (this.checkRideRequest?.ApplicantAcsWrittenResult?.AcsTestId && this.lastCheckRideRequest?.CheckRideTypeId == this.checkRideRequest.CheckRideTypeId) {
  //     return;
  //   }

  //   this.planOfActionRepositoryService.getAcsTestByCheckRideType(this.checkRideRequest?.CheckRideTypeId)
  //     .subscribe(acsTestCheckRideType => {

  //       const checkrideRequest = this.formApi.getFormData<CheckRideRequestEntity>();

  //       if (acsTestCheckRideType?.AcsTestId) {
  //         if (checkrideRequest.ApplicantAcsWrittenResult?.AcsTestId == acsTestCheckRideType.AcsTestId) {
  //           return;
  //         }

  //         if (checkrideRequest.ApplicantAcsWrittenResult == null) {
  //           checkrideRequest.ApplicantAcsWrittenResult = AppMetaData.ApplicantAcsWrittenResult.CreateEntity();
  //         }

  //         const checkrideRequestUpdate: Partial<CheckRideRequestEntity> = {
  //           ApplicantAcsWrittenResult: deepCopy(this.checkRideRequest.ApplicantAcsWrittenResult)
  //         };

  //         console.log('Setting Acs Test from Checkride Type Id - ', this.checkRideRequest.CheckRideTypeId);
  //         checkrideRequestUpdate.ApplicantAcsWrittenResult.AcsTestId = acsTestCheckRideType.AcsTestId;

  //         this.formApi.patchFormData(checkrideRequestUpdate);
  //       }
  //     });
  // }

  setAcsTest() {
    if (!this.checkRideRequest?.CheckRideTypeId || !this.allAcsTests) {
      return;
    }

    const checkrideUpdate: Partial<CheckRideRequestEntity> = {};

    // if (this.checkRideRequest?.ApplicantAcsWrittenResult?.AcsTestId && this.lastCheckRideRequest?.CheckRideTypeId == this.checkRideRequest.CheckRideTypeId) {
    //   return;
    // }

    const acsTestCheckRideType = this.allAcsTests.find(a => a.CheckRideTypeId == this.checkRideRequest.CheckRideTypeId);

    if (!acsTestCheckRideType?.AcsTestId) {
      return;
    }

    let updated = false;

    if (this.checkRideRequest.ApplicantAcsWrittenResult?.AcsTestId != acsTestCheckRideType.AcsTestId) {
      checkrideUpdate.ApplicantAcsWrittenResult = deepCopy(checkrideUpdate.ApplicantAcsWrittenResult) || AppMetaData.ApplicantAcsWrittenResult.CreateEntity();

      //this.schoolDebug('Setting Acs Test from Checkride Type Id - ', this.checkRideRequest.CheckRideTypeId);
      checkrideUpdate.ApplicantAcsWrittenResult.AcsTestId = acsTestCheckRideType.AcsTestId;

      updated = true;
    }

    let newAcsTestId = this.checkRideRequest.ApplicantAcsWrittenResult?.AcsTestId;

    if (updated) {
      newAcsTestId = checkrideUpdate.ApplicantAcsWrittenResult.AcsTestId;
    }

    const showOutcome = this.shouldShowOutcome(this.checkRideRequest.CheckRideRequestSubStatusId);
    // Update the result test
    if (showOutcome && this.checkRideRequest.CheckRideResult.PostApplicantAcsWrittenResult?.AcsTestId != acsTestCheckRideType.AcsTestId) {
      checkrideUpdate.CheckRideResult = deepCopy(this.checkRideRequest.CheckRideResult);

      if (!this.checkRideRequest.CheckRideResult.PostApplicantAcsWrittenResult) {
        checkrideUpdate.CheckRideResult.PostApplicantAcsWrittenResult = AppMetaData.ApplicantAcsWrittenResult.CreateEntity();
      }


      checkrideUpdate.CheckRideResult.PostApplicantAcsWrittenResult.AcsTestId = newAcsTestId;

      updated = true;
    }

    if (updated) {
      this.formApi.patchContextData(DwMdFormContextInfo.DATA_CONTEXT_NAME, checkrideUpdate);
      this.formApi.formGroup.patchValue(checkrideUpdate);
      this.formApi.patchFormData(checkrideUpdate);
    }

  }

  private shouldShowOutcome(checkRideRequestSubStatusId: number): boolean {
    const statusIds: number[] = [];

    statusIds.push(CheckRideRequestSubStatusAllItems.PendingOutcome);
    statusIds.push(CheckRideRequestSubStatusAllItems.Completed);

    return statusIds.includes(checkRideRequestSubStatusId);
  }

  updateCheckrideScenarioDefaults(checkrideScenario: CheckRideScenarioEntity) {
    const checkrideRequest: Partial<CheckRideRequestEntity> = {
      ScheduledCheckRideScenarioId: checkrideScenario.CheckRideScenarioId,
      //ScheduledTimeMinutes: checkrideScenario.TimeRequiredMinutes,
      ScheduledTimeMinutes: this.examinerRepositoryService.getCheckrideTimeMinutesFromScenario(this.checkRideRequest.CheckRideTestTypeId, checkrideScenario),
      ScheduledPreTimeMinutes: checkrideScenario.PreTimeMinutes,
      ScheduledPostTimeMinutes: checkrideScenario.PostTimeMinutes,
      ScheduledCheckRideCost: checkrideScenario.CheckRideCost,
      AdditionalTravelCost: checkrideScenario.TravelCost,
      ExaminerBookingCost: checkrideScenario.BookingCost,
      ExaminerToApplicantNotes: checkrideScenario.RequiredDocumentNotes,
    };



    setTimeout(() => {
      //this.formGroup.patchValue(checkrideRequest);
      this.formApi.patchFormData(checkrideRequest);
    }, 50);
  }


  updateCheckRideResultActualDateTime() {
    const checkrideResult: Partial<CheckRideResultEntity> = {
      CheckRideDateTime: this.checkRideRequest.ScheduledDateTime,
    };



    const checkrideRequest: Partial<CheckRideRequestEntity> = {
      CheckRideResult: checkrideResult as CheckRideResultEntity
    };

    // Only update the status if an outcome has been selected
    if (this.checkRideRequest.CheckRideResult.CheckRideOutcomeId) {
      checkrideRequest.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.Completed;
    }

    setTimeout(() => {
      this.formApi.patchFormData(checkrideRequest);
    }, 50);
  }

  previousScheduleDateTime: string;

  variables = {
    checkride_DateTime_Conflict: 'Checkride_DateTime_Conflict',
    proposed_DateTime_Conflict: 'Proposed_DateTime_Conflict',
  }

  checkForScheduleDateTimeChange() {
    if (!this.checkRideRequest) {
      return;
    }

    if (this.previousScheduleDateTime != this.checkRideRequest.ScheduledDateTime) {
      // this.checkCalendarAvailability(this.checkRideRequest.ScheduledDateTime, this.variables.checkride_DateTime_Conflict);
    }

    if (!this.rescheduleInfo) {
      return;
    }

    if (this.rescheduleInfo.proposedStartDateTime) {
      return;
    }

    if (this.rescheduleInfo.startDateTime) {
      if (this.checkRideRequest.ScheduledDateTime != this.rescheduleInfo.startDateTime) {
        this.checkRideRequest.ScheduledDateTime = this.rescheduleInfo.startDateTime;
        this.formGroup.patchValue(this.checkRideRequest);
      }
    }
  }

  rebookComplete?: boolean;

  checkForRebook() {
    if (this.rebookComplete || this.dwMetaDataFormStateService.state.formContext.contextMode != DwFormContextMode.add) {
      return;
    }

    // We want to wait until the defaults have been loaded
    if (!this.dwMetaDataFormStateService.state.formContext.defaultsProcessed) {
      return;
    }

    const variables = this.formApi.getVariableContextValue<ExaminerBookingVariableContext>();

    if (!variables?.RebookCheckrideId) {
      return;
    }

    this.rebookComplete = true;
    this.isRebook = true;


    this.examinerRepositoryService.getRebookCheckrideRequest(variables.RebookCheckrideId)
      .subscribe(checkride => {
        // Wait a half second to make sure the form is loaded
        setTimeout(() => {
          this.updateCheckrideForRebook(checkride);
        });
      });



  }

  updateCheckrideForRebook(checkride: CheckRideRequestEntity) {
    if (!checkride) {
      return;
    }
    this.rebookComplete = true;

    const updatedCheckride = this.examinerRepositoryService.prepareCheckrideForCopy(checkride, this.testTypes, this.outcomes);

    let waivePayment = this.examinerRepositoryService.getWaiveCheckridePaymentOnRebook(checkride);

    // Set the preferred pilot examiner to the same as before
    const variables: Partial<ExaminerBookingVariableContext> = {
      Pilexos_Payment_Waived: waivePayment,
      RebookCheckrideId: checkride.CheckRideRequestId
    };

    this.formApi.patchVariableContext(variables);

    updatedCheckride.PilexosBookingPaymentAdded = waivePayment;

    if (!this.checkRideRequest.CheckRideRequestSubStatusId) {
      updatedCheckride.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.Accepted;
    }

    if (waivePayment) {
      updatedCheckride.PilexosBookingCost = 0;
      updatedCheckride.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.Accepted;
    }

    // Clear scheduled fields
    updatedCheckride.ScheduledDateTime = null;

    if (checkride.CheckRideResult?.RetestCost) {
      updatedCheckride.ScheduledCheckRideCost = checkride.CheckRideResult?.RetestCost;
    }


    // Set these fields for it doesn't get overritten by the scenario logic
    this.checkRideTypeId = checkride.CheckRideTypeId;
    this.checkrideScenarioId = checkride.ScheduledCheckRideScenarioId;

    this.formApi.patchFormData(updatedCheckride);
  }


  private handleReschedule() {
    const scheduleUTCDateTime = formatDateTimeFromLocal(this.rescheduleInfo.proposedStartDateTime, true, true);

    switch (this.checkRideRequest.CheckRideRequestSubStatusId) {
      case CheckRideRequestSubStatusAllItems.PendingApproval:
      case CheckRideRequestSubStatusAllItems.NewDateProposedByExaminer:
      case CheckRideRequestSubStatusAllItems.RequiresAdditionalInfo:
      case CheckRideRequestSubStatusAllItems.RequiresAdditionalInfo:
        break;

      default:
        return;
    };

    const partialCheckRequestRequest: Partial<CheckRideRequestEntity> = {
      ProposedDateTime: scheduleUTCDateTime,
      ProposedAirportId: this.checkRideRequest.ScheduledAirportId,
      ProposedTimeMinutes: this.checkRideRequest.ScheduledTimeMinutes,
      CheckRideRequestSubStatusId: CheckRideRequestSubStatusAllItems.NewDateProposedByExaminer
    };

    this.checkRideRequest.CheckRideRequestSubStatusId = partialCheckRequestRequest.CheckRideRequestSubStatusId;

    // Patch the form data
    this.formApi.patchFormData(partialCheckRequestRequest);
  }

  private updateProposedInfo(checkRideRequest: CheckRideRequestEntity) {

    const partialCheckRequestRequest: Partial<CheckRideRequestEntity> = {
      ProposedDateTime: checkRideRequest.ScheduledDateTime,
      ProposedAirportId: checkRideRequest.ScheduledAirportId,
      ProposedTimeMinutes: checkRideRequest.ScheduledTimeMinutes,
    };

    // Patch the form data
    this.formApi.patchFormData(partialCheckRequestRequest);
  }
}

